



























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getBookingsPrescriberStream } from '@/api/api';
import MetaDatatable from '@/models/MetaDatatable';
import HeaderDatatable from '@/models/HeaderDatatable';
import Datatable from '@/components/Datatable.vue';
import { formatBookingProgression, bookingProgressionColors, bookingProgression } from '@/data/bookingProgression';
import { formatBookingStatus, bookingStatusColors, bookingStatus } from '@/data/bookingStatus';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { getTaxSystemValue } from '@/data/taxSystems';
import Booking from '@/models/Booking';
import Secret from '@/components/common/Secret.vue';

@Component({
    components: {
        Datatable,
        Secret,
    },
    filters: {
        getTaxSystemValue,
        formatBookingProgression,
        formatBookingStatus,
        formatDate: (value: string) => {
            return value ? moment(value).format('DD/MM/YYYY') : '-';
        },
        formatCurrency: (value: number) => {
            return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
        }
    },
})
export default class BookingsPrescriber extends Vue {
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 50,
        search: null,
        orderBy: 'created_at',
        orderWay: 'DESC',
        filters: {
            ProgressionResaModel: undefined,
            StatutResa: undefined,
            year: new Date().getFullYear().toString()
        },
    };
    
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    yearModel: string = new Date().getFullYear().toString();
    ProgressionResaModel: string | undefined | null = null;
    StatutResaModel: string | undefined | null = null;
    searchQuery: string = '';

    // Safety check for corrupted data
    isBookingValid(booking: Booking) {
        return booking && booking.customer && booking.lot && booking.lot.program;
    }

    getCommissionDisplay(tauxCommission: any): string {
        if (tauxCommission === null || tauxCommission === undefined || tauxCommission === '') {
            return 'NC';
        }

        const value = Number(tauxCommission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }

    get columns(): HeaderDatatable[] {
        return [
            { title: 'Code', dataIndex: 'code', width: 180, sorter: true, scopedSlots: { customRender: 'code' } },
            { title: 'Date', dataIndex: 'created_at', width: 130, sorter: true, scopedSlots: { customRender: 'date' } },
            { title: 'Client', dataIndex: 'customer', sorter: true, scopedSlots: { customRender: 'customer' } },
            { title: 'Programme', dataIndex: 'lot.program', sorter: true, scopedSlots: { customRender: 'program' } },
            { title: 'Lot', dataIndex: 'lot', width: 180, sorter: true, scopedSlots: { customRender: 'lot' } },
            { title: 'Prix', dataIndex: 'lot.price', width: 150, sorter: true, scopedSlots: { customRender: 'price' } },
            { title: 'Taux commission confirmé', dataIndex: 'taux_commission', width: 150, scopedSlots: { customRender: 'commission' } },
            { title: 'Honoraires', dataIndex: 'program', width: 130, scopedSlots: { customRender: 'hono' } },
            { title: 'Avancement', dataIndex: 'progression', width: 180, sorter: true, scopedSlots: { customRender: 'progression' } },
            { title: 'Statut', dataIndex: 'status', width: 150, sorter: true, scopedSlots: { customRender: 'status' } }
        ];
    }

    fetch(meta: MetaDatatable) {
        const QUICK_ROWS = 10;

        let quickResolve!: (v: any) => void;
        let fullResolve!: (v: any) => void;

        const quickPromise = new Promise<any>(res => { quickResolve = res; });
        const fullPromise  = new Promise<any>(res => { fullResolve  = res; });

        this.streamBookings(meta, QUICK_ROWS, quickResolve, fullResolve);

        return { quick: quickPromise, full: fullPromise };
    }

    async streamBookings(
        meta: MetaDatatable,
        quickRows: number,
        quickResolve: (v: any) => void,
        fullResolve: (v: any) => void
    ) {
        const rows: any[]  = [];
        let metaData: any  = null;
        let quickFired     = false;

        const emptyMeta = { total: 0, pages: 0, page: 0, perPage: meta.perPage || 50 };

        try {
            const response = await getBookingsPrescriberStream({ ...meta, page: meta.page - 1 });

            if (!response.ok || !response.body) {
                throw new Error(`HTTP ${response.status}`);
            }

            const reader  = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer    = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n');
                buffer = lines.pop()!;

                for (const line of lines) {
                    if (!line.trim()) continue;
                    const item = JSON.parse(line);
                    if (item.type === 'meta') {
                        metaData = item.data;
                    } else if (item.type === 'booking') {
                        rows.push(item.data);
                        if (!quickFired && rows.length >= quickRows && metaData) {
                            quickFired = true;
                            quickResolve({ data: [...rows], meta: metaData });
                        }
                    }
                }
            }

            const finalMeta = metaData || { ...emptyMeta, total: rows.length };
            if (!quickFired) quickResolve({ data: rows, meta: finalMeta });
            fullResolve({ data: rows, meta: finalMeta });

        } catch (e) {
            console.error('Erreur chargement réservations:', e);
            if (!quickFired) quickResolve({ data: [], meta: emptyMeta });
            fullResolve({ data: [], meta: emptyMeta });
        }
    }

    get bookingProgressionColors() { return bookingProgressionColors; }
    get bookingStatusColors() { return bookingStatusColors; }
    
    get bookingProgressionArr(){
        return Object.keys(bookingProgression).map(key => ({ text: (bookingProgression as any)[key], value: key }));
    }

    get bookingStatusArr(){
        return Object.keys(bookingStatus).map(key => ({ text: (bookingStatus as any)[key], value: key }));
    }

    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let year = currentYear; year >= 2020; year--) {
            years.push({ text: year.toString(), value: year.toString() });
        }
        return years;
    }

    @Watch('yearModel')
    onYearModel() {
        if (this.yearModel) {
            localStorage.setItem('prescriber_year_filter', this.yearModel);
            this.meta.filters = { ...this.meta.filters, year: this.yearModel };
            if (this.$refs.datatable) {
                (this.$refs.datatable as any).refresh();
            }
        }
    }

    @Watch('ProgressionResaModel')
    onProgressionResaModel() {
        this.meta.filters = { ...this.meta.filters, progressionResa: this.ProgressionResaModel || null };
        if (this.$refs.datatable) {
            (this.$refs.datatable as any).refresh();
        }
    }

    @Watch('StatutResaModel')
    onStatutResaModel() {
        this.meta.filters = { ...this.meta.filters, StatutResa: this.StatutResaModel || null };
        if (this.$refs.datatable) {
            (this.$refs.datatable as any).refresh();
        }
    }

    @Watch('searchQuery')
    onSearchQuery() {
        this.meta.search = this.searchQuery || null;
    }

    created() {
        this.resetFilters();
    }


    resetFilters() {
        this.ProgressionResaModel = undefined;
        this.StatutResaModel = undefined;
        
        const storedYear = localStorage.getItem('prescriber_year_filter');
        this.yearModel = storedYear || new Date().getFullYear().toString();
        
        this.meta = cloneDeep(this.defaultMeta);
        this.meta.filters.year = this.yearModel;
    }



    activated() {
            this.$nextTick(() => {
                if (this.$refs.datatable) {
                    (this.$refs.datatable as any).refresh();
                }
            });
        }


    beforeRouteEnter(to: any, from: any, next: any) {
            next((vm: any) => {
                if (from && from.name !== 'bookingPrescriber') {
                    vm.resetFilters();
                }
            });
        }





}
